import React, { useState } from "react";
import { Link } from "react-router-dom";
import api from "../lib/api";
import { Button } from "../components/ui/button";
import { Input } from "../components/ui/input";
import { Label } from "../components/ui/label";
import { toast } from "sonner";

export default function ForgotPassword() {
  const [email, setEmail] = useState("");
  const [sent, setSent] = useState(false);
  const submit = async (e) => {
    e.preventDefault();
    try {
      await api.post("/auth/forgot-password", { email });
      setSent(true);
    } catch {
      setSent(true);
    }
  };
  return (
    <div className="min-h-screen flex items-center justify-center bg-[#F8FAFC] p-6">
      <form onSubmit={submit} className="w-full max-w-sm space-y-5 bg-white p-8 rounded-xl border">
        <h2 className="text-2xl font-bold text-slate-900">Reset password</h2>
        {sent ? (
          <p className="text-sm text-slate-600">If that email is registered, a reset link has been sent.</p>
        ) : (
          <>
            <p className="text-sm text-slate-500">Enter your email and we'll send a reset link.</p>
            <div>
              <Label>Email</Label>
              <Input type="email" value={email} onChange={(e) => setEmail(e.target.value)} required />
            </div>
            <Button type="submit" className="w-full">Send reset link</Button>
          </>
        )}
        <div className="text-center"><Link to="/login" className="text-sm text-blue-600 hover:underline">Back to sign in</Link></div>
      </form>
    </div>
  );
}
